export default function Label({ children, className = "" }) {
    return (
        <div className={`tm-label flex items-center gap-2.5 ${className}`}>
            <span className="inline-block w-4 h-px bg-[hsl(var(--tm-gold))]" aria-hidden="true"></span>
            {children}
        </div>
    );
}
